import { useNavigate } from 'react-router-dom';

import { IconBack } from '@/components/icons/icons';
interface Props {
  onClick?: () => void;
  style?: React.CSSProperties;
}

const Back = ({ onClick, style }: Props) => {
  const navigate = useNavigate();
  return (
    <IconBack
      onClick={() => {
        if (onClick) {
          onClick();
        } else {
          navigate(-1);
        }
      }}
      style={{ width: '0.4rem', height: '0.6rem', cursor: 'pointer', ...style }}
    />
  );
};

export default Back;
